//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../no/Builder.js";
import "../Diagramming/Diagramming.SheetBorderSettingsBuilder.js";
import "../Diagramming/Diagramming.SheetMarginSettingsBuilder.js";
import "../Diagramming/Diagramming.SheetZoneSettingsBuilder.js";
let d=[[[0,"BottomMargin",1,1],[0,"CenteringMarkExtension",1,1],[0,"CreateBorders",1,1],[0,"CreateTrimmingMarks",1,1],[0,"CreateZoneLabels",1,1],[0,"CreateZoneMarking",1,1],[0,"HorizontalCenteringMark",1,1],[0,"HorizontalSize",1,1],[0,"LabelFont",1,1],[0,"LabelHeight",1,1],[0,"LeftMargin",1,1],[0,"MarkingHeight",1,1],[0,"Method",1,1],[0,"Origin",1,1],[0,"RightMargin",1,1],[1,"SheetBorderSettings",0,"Diagramming.SheetBorderSettingsBuilder",0],[1,"SheetMarginSettings",0,"Diagramming.SheetMarginSettingsBuilder",0],[1,"SheetZoneSettings",0,"Diagramming.SheetZoneSettingsBuilder",0],[0,"TopMargin",1,1],[0,"TrimmingMarkLength",1,1],[0,"TrimmingMarkThickness",1,1],[0,"VerticalCenteringMark",1,1],[0,"VerticalSize",1,1],[0,"Width",1,1]],[[["owningSheet"],"SetOwningSheet",{},1,0]],[]];
SPLM.Diagramming.SheetBordersAndZonesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.SheetBordersAndZonesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Diagramming.SheetBordersAndZonesBuilder.HorizontalCenteringMarkType = Object.freeze({
    "None" : "None", "LeftArrow" : "LeftArrow", "RightArrow" : "RightArrow", "LeftandRightArrow" : "LeftandRightArrow", "LeftandRightLine" : "LeftandRightLine"});

SPLM.Diagramming.SheetBordersAndZonesBuilder.VerticalCenteringMarkType = Object.freeze({
    "None" : "None", "BottomArrow" : "BottomArrow", "TopArrow" : "TopArrow", "BottomandTopArrow" : "BottomandTopArrow", "BottomandTopLine" : "BottomandTopLine"});

SPLM.Diagramming.SheetBordersAndZonesBuilder.ZoneMethod = Object.freeze({
    "None" : "None", "Standard" : "Standard", "Custom" : "Custom"});

SPLM.Diagramming.SheetBordersAndZonesBuilder.ZoneOrigin = Object.freeze({
    "BottomRight" : "BottomRight", "TopLeft" : "TopLeft", "TopRight" : "TopRight", "BottomLeft" : "BottomLeft"});

SPLM.Diagramming.SheetBordersAndZonesBuilder.ArrowStyleType = Object.freeze({
    "Filled" : "Filled", "Closed" : "Closed", "ClosedSolid" : "ClosedSolid", "Open" : "Open"});

SPLM.Diagramming.SheetBordersAndZonesBuilder.ArrowDirectionType = Object.freeze({
    "OutofSheet" : "OutofSheet", "IntoSheet" : "IntoSheet"});

SPLM.Diagramming.SheetBordersAndZonesBuilder.TrimmingMarkStyleType = Object.freeze({
    "Triangle" : "Triangle", "Corner" : "Corner"});

export default SPLM;